import React from 'react';
import { PaymentMethod } from '../../../types/Configuration';
import PaymentMethodForm from '../../input/PaymentMethodForm';
import SectionTitle from '../../content/SectionTitle';
import CustomMessage from '../../content/CustomMessage';
import { AmazonPayCheckoutButtonProps } from '../../payment/AmazonPayCheckoutButton';
import { PayPalAcpMethods, PayPalButtonMethods } from '../../../types/PayPal';
import { SpreedlyNewPaymentMethodEventHandlers } from '../../../types/Spreedly';

export const PaymentMethodSectionTestId = 'PaymentMethodSection-input';

export type PaymentMethodSectionProps = {
  hasRecurringBillingItem?: boolean;
  amazonPayButtonProps: AmazonPayCheckoutButtonProps;
  customPayMessage: string | null;
  paymentMethods: PaymentMethod[];
  payPalButtonMethods: PayPalButtonMethods;
  payPalAcpMethods?: PayPalAcpMethods;
  spreedlyEventHandlers?: SpreedlyNewPaymentMethodEventHandlers;
  onPaymentMethodChanged?: (paymentMethodId: string | null) => void;
};

const PaymentMethodSectionWithFormContext: React.FC<
  PaymentMethodSectionProps
> = ({
  hasRecurringBillingItem,
  amazonPayButtonProps,
  customPayMessage,
  paymentMethods,
  payPalButtonMethods,
  payPalAcpMethods,
  spreedlyEventHandlers,
  onPaymentMethodChanged,
}: PaymentMethodSectionProps) => {
  return (
    <div data-testid={PaymentMethodSectionTestId}>
      <SectionTitle>Payment</SectionTitle>
      {!!customPayMessage && <CustomMessage customMessage={customPayMessage} />}
      <div className="px-2 mb-6">
        <PaymentMethodForm
          onPaymentMethodChanged={onPaymentMethodChanged}
          hasRecurringBillingItem={hasRecurringBillingItem}
          paymentMethods={paymentMethods}
          payPalButtonMethods={payPalButtonMethods}
          payPalAcpMethods={payPalAcpMethods}
          amazonPayButtonProps={amazonPayButtonProps}
          spreedlyEventHandlers={spreedlyEventHandlers}
        />
      </div>
    </div>
  );
};

export default PaymentMethodSectionWithFormContext;
